import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column align-center mb-6" }
const _hoisted_2 = {
  key: 2,
  class: "text-caption mt-2 text-grey"
}
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "mr-1 flex-grow-1" }
const _hoisted_5 = { class: "ml-1 flex-grow-1" }
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = { class: "mr-1 flex-grow-1" }
const _hoisted_8 = { class: "ml-1 flex-grow-1" }
const _hoisted_9 = { class: "d-flex align-center" }
const _hoisted_10 = { class: "d-flex justify-center mt-8 mb-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_form, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.pickedImg)
              ? (_openBlock(), _createBlock(_component_v_avatar, {
                  key: 0,
                  size: "100",
                  onClick: _ctx.pickFile,
                  style: {"cursor":"pointer"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_img, {
                      src: _ctx.pickedImg,
                      cover: ""
                    }, null, 8, ["src"])
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["file_uploader pa-3", [{ '-drag': _ctx.isDrag === 'new' }]]),
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.pickFile && _ctx.pickFile(...args))),
                  onDragover: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.checkDrag($event, 'new', true)), ["prevent"])),
                  onDragleave: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.checkDrag($event, 'new', false)), ["prevent"])),
                  onDrop: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)), ["prevent"]))
                }, [
                  _createVNode(_component_v_icon, {
                    color: "primary",
                    size: "x-large"
                  }, {
                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                      _createTextVNode("mdi-camera", -1)
                    ]))]),
                    _: 1
                  })
                ], 34)),
            _createElementVNode("input", {
              class: "d-none",
              ref: "fileInput",
              type: "file",
              onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args))),
              accept: ".png,.jpg,image/jpeg,image/png"
            }, null, 544),
            (_ctx.pickedImg)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "タップで変更"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-body-2 text-blue-grey mb-1" }, "姓", -1)),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.postMeRequest.lastName,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.postMeRequest.lastName) = $event)),
                variant: "outlined",
                density: "compact"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[16] || (_cache[16] = _createElementVNode("p", { class: "text-body-2 text-blue-grey mb-1" }, "名", -1)),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.postMeRequest.firstName,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.postMeRequest.firstName) = $event)),
                variant: "outlined",
                density: "compact"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[17] || (_cache[17] = _createElementVNode("p", { class: "text-body-2 text-blue-grey mb-1" }, "せい", -1)),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.postMeRequest.lastNameKana,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.postMeRequest.lastNameKana) = $event)),
                variant: "outlined",
                density: "compact"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[18] || (_cache[18] = _createElementVNode("p", { class: "text-body-2 text-blue-grey mb-1" }, "めい", -1)),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.postMeRequest.firstNameKana,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.postMeRequest.firstNameKana) = $event)),
                variant: "outlined",
                density: "compact"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[19] || (_cache[19] = _createElementVNode("p", { class: "text-body-2 text-blue-grey mb-1" }, "生年月日", -1)),
            _createVNode(_component_v_text_field, {
              modelValue: _ctx.postMeRequest.birth,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.postMeRequest.birth) = $event)),
              type: "date",
              max: _ctx.maxDate,
              min: "1950-01-01",
              variant: "outlined",
              density: "compact"
            }, null, 8, ["modelValue", "max"])
          ]),
          _createElementVNode("div", null, [
            _cache[20] || (_cache[20] = _createElementVNode("p", { class: "text-body-2 text-blue-grey mb-1" }, "血液型", -1)),
            _createVNode(_component_v_text_field, {
              modelValue: _ctx.postMeRequest.bloodType,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.postMeRequest.bloodType) = $event)),
              variant: "outlined",
              density: "compact"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _cache[23] || (_cache[23] = _createElementVNode("p", { class: "text-body-2 text-blue-grey mb-1" }, "電話番号", -1)),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.tel1,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.tel1) = $event)),
                variant: "outlined",
                density: "compact",
                "hide-details": ""
              }, null, 8, ["modelValue"]),
              _cache[21] || (_cache[21] = _createElementVNode("span", { class: "mx-2" }, "-", -1)),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.tel2,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.tel2) = $event)),
                variant: "outlined",
                density: "compact",
                "hide-details": ""
              }, null, 8, ["modelValue"]),
              _cache[22] || (_cache[22] = _createElementVNode("span", { class: "mx-2" }, "-", -1)),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.tel3,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.tel3) = $event)),
                variant: "outlined",
                density: "compact",
                "hide-details": ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_v_btn, {
              onClick: _ctx.postMe,
              color: "primary",
              block: "",
              size: "large",
              loading: _ctx.isSubmitting
            }, {
              default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                _createTextVNode(" 送信 ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick", "loading"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}